// PN-11 (T-430) — l'état de la synchronisation Pennylane d'un dossier (date, fraîcheur, écarts) : un outil de diagnostic, rangé dans
// « Outils avancés » (super admin). Avant, ces lignes comptaient comme des champs « à remplir » dans le compteur de l'onglet Finance.
import { hasIntegrationPennylane } from "../../../utils/tenantProfile";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../../components/ui/dialog";

export function SynchroPennylaneDialog({ ouvert, onFermer, dossier }) {
  // T-432 : rien de Pennylane pour un tenant qui ne déclare pas l'intégration (même garde que l'entrée de menu, et que le test d'exhaustivité des écrans Pennylane).
  if (!hasIntegrationPennylane()) return null;
  const ecarts = dossier?.facture_divergences || [];
  const fraiche = dossier?.facture_snapshot_frais;
  return (
    <Dialog open={ouvert} onOpenChange={(o) => { if (!o) onFermer(); }}>
      <DialogContent data-testid="synchro-pennylane-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>Synchronisation Pennylane</DialogTitle>
          <DialogDescription>Outil de diagnostic : l'état des factures de ce dossier tel que Pennylane l'a donné la dernière fois.</DialogDescription>
        </DialogHeader>
        <dl className="text-sm space-y-2" style={{ color: "var(--oh-text)" }}>
          <div><dt style={{ color: "var(--oh-text-muted)" }}>Dernière synchronisation</dt><dd>{dossier?.facture_synchro_le || "Date inconnue"}</dd></div>
          <div><dt style={{ color: "var(--oh-text-muted)" }}>Fraîcheur des données</dt>
            <dd>{fraiche === false ? "Les données n'ont pas été rafraîchies : elles peuvent être périmées." : fraiche === true ? "À jour." : "Inconnue."}</dd></div>
          <div><dt style={{ color: "var(--oh-text-muted)" }}>Écarts avec OmniHub</dt>
            <dd data-testid="synchro-ecarts">{ecarts.length ? <ul className="list-disc pl-4">{ecarts.map((e, i) => <li key={i}>{e}</li>)}</ul> : "Aucun écart."}</dd></div>
          {dossier?.facture_payee_motif && (
            <div><dt style={{ color: "var(--oh-text-muted)" }}>Pourquoi l'état de paiement est celui-là</dt><dd>{dossier.facture_payee_motif}</dd></div>
          )}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
